import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { reaction, action, observable } from 'mobx';
import { FormattedMessage } from 'ui/i18n';
import { parse as qs_parse } from 'query-string';
import { INTERNAL_ERROR, BAD_REQUEST } from 'config/constants';
import { authorize } from 'utils/auth';
import { getIndex } from 'utils/helpers';
import { getYesNoValue } from 'api/helpers';

import {
	render_date,
	render_amount,
	render_solo_item_package,
	render_yes_no,
	render_editable_number,
	render_quantity,
} from 'utils';

import {
	DataTable,
	Loader,
	ItemPreview,
	PageHeader,
	ItemContentHeader,
	GoBack,
	ErrorLoadingContent,
	Alert,
	PromotionBreadcrumb,
} from 'ui/components';

import './ItemDetailsPack.scss';

function getColumnsItem(onChangeQty, onBlurHandler) {
	return [
		{
			prop: 'list_price',
			title: <FormattedMessage id="itemsTable.listColumn" />,
			align: 'right',
			render(row) {
				return render_amount(row[this.prop], row);
			},
			noWrap: true,
		},
		{
			prop: 'quantity',
			title: <FormattedMessage id="itemsTable.qtyColumn" />,
			align: 'center',
			render(row) {
				return render_quantity(row[this.prop]);
			},
		},
		{
			prop: 'ta',
			title: <FormattedMessage id="itemsTable.TAColumn" />,
			render(row) {
				return `${row[this.prop]}%`;
			},
			align: 'right',
		},
		{
			prop: 'net_price',
			title: <FormattedMessage id="itemsTable.netColumn" />,
			align: 'right',
			render(row) {
				return render_amount(row[this.prop], row);
			},
			noWrap: true,
		},
		{
			prop: 'est_ship_date',
			title: <FormattedMessage id="itemsTable.estShipColumn" />,
			align: 'center',
			render() {
				return <FormattedMessage id="item.See_Components" />;
			},
		},
		{
			prop: 'invoice_hold_weeks',
			title: <FormattedMessage id="itemsTable.numberHoldInvWksColumn" />,
			align: 'center',
			render() {
				return <FormattedMessage id="item.See_Components" />;
			},
		},
		{
			prop: 'is_drop_ship',
			title: <FormattedMessage id="itemsTable.dropShipColumn" />,
			align: 'center',
			render(row) {
				return render_yes_no(getYesNoValue(row[this.prop]));
			},
		},
		{
			prop: 'id',
			title: <FormattedMessage id="itemsTable.addToCartQtyColumn" />,
			align: 'center',
			render(row) {
				return render_editable_number(
					row,
					null,
					false,
					onChangeQty,
					onBlurHandler
				);
			},
		},
	];
}

function getColumnsPack(totalCount) {
	return [
		{
			prop: 'id',
			title: (
				<FormattedMessage
					id="packDetails.totalItemsInPackage"
					values={{ totalCount }}
				/>
			),
			render(row) {
				return render_solo_item_package(row[this.prop], row);
			},
		},
		{
			prop: 'quantity_in_pack',
			title: <FormattedMessage id="itemsTable.qtyColumn" />,
			align: 'center',
		},
		{
			prop: 'list_price',
			title: <FormattedMessage id="itemsTable.listColumn" />,
			align: 'right',
			render(row) {
				return render_amount(row[this.prop], row);
			},
			noWrap: true,
		},
		{
			prop: 'promo_price',
			title: <FormattedMessage id="itemsTable.promoColumn" />,
			align: 'right',
			render(row) {
				return render_amount(row[this.prop], row);
			},
			noWrap: true,
		},
		{
			prop: 'ta',
			title: <FormattedMessage id="itemsTable.TAColumn" />,
			render(row) {
				return `${row[this.prop]}%`;
			},
			align: 'right',
		},
		{
			prop: 'net_price',
			title: <FormattedMessage id="itemsTable.netColumn" />,
			align: 'right',
			render(row) {
				return render_amount(row[this.prop], row);
			},
			noWrap: true,
		},
		{
			prop: 'est_ship_date',
			title: <FormattedMessage id="itemsTable.estShipColumn" />,
			align: 'center',
			render(row) {
				return render_date(row[this.prop]);
			},
		},
		{
			prop: 'invoice_hold_weeks',
			title: <FormattedMessage id="itemsTable.numberHoldInvWksColumn" />,
			align: 'center',
		},
	];
}

@authorize({ rights: ['GetDetails'] })
@inject('ItemsState', 'UIState', 'CartState', 'CartItemsState')
@observer
export default class ItemDetailsPackPage extends Component {
	static propTypes = {
		ItemsState: PropTypes.object.isRequired,
		UIState: PropTypes.object.isRequired,
		CartState: PropTypes.object.isRequired,
		CartItemsState: PropTypes.object.isRequired,
		history: PropTypes.object.isRequired,
	};

	componentWillMount() {
		this.ItemsState.fetchItemDetailsPack(this.getUrlParams());

		reaction(
			() => this.ItemsState.fetchItemDetailsPack.state.result,
			result =>
				result &&
				this.props.UIState.setSelectedPromotion({
					category_id: result.packDetails[0].category_id,
					promo_id: result.packDetails[0].promotion_id,
					country_short_name: result.packDetails[0].currency.country_short_name,
				})
		);
	}

	componentWillUnmount() {
		this.props.UIState.deselectPromotionInMenu(
			parseInt(this.urlParams.categoryId, 0)
		);
		this.CartItemsState.emptyCurrentCart();
		this.props.CartState.removeAPIError();
	}

	@observable showModal = false;
	ItemsState = this.props.ItemsState;
	CartState = this.props.CartState;
	CartItemsState = this.props.CartItemsState;
	history = this.props.history;

	urlParams = this.getUrlParams();

	getUrlParams() {
		return qs_parse(window.location.search);
	}

	onChangeQty(value, item) {
		if (value) {
			item.quantity_ordered = value;
			item.errorMsgId = this.CartItemsState.getErrorMessageId(
				false,
				this.CartState.getAvailableQuantity(item, false),
				this.CartState.getTotalQuantityFromCart(item),
				item
			);
			this.CartItemsState.addToCurrentCart(item);
		} else {
			this.CartItemsState.deleteFromCart(item);
		}
	}

	onBlurHandler(item) {
		const index = getIndex(
			this.CartItemsState.cartUpdates,
			'number',
			item.number
		);

		if (
			index >= 0 &&
			item.is_configurable &&
			item.quantity_ordered &&
			!item.errorMsgId
		) {
			this.toggleModal(item);
		}
	}

	@action
	toggleModal() {
		this.ItemsState.fetchItemDetailsPack(this.getUrlParams());
		this.showModal = !this.showModal;
	}

	@action
	handleAddToCart() {
		this.showModal = false;

		if (this.CartItemsState.isCurrentCartEmpty) {
			this.CartItemsState.toggleWarningMessage();
		} else {
			this.CartState.addToCart(this.CartItemsState.cartUpdates).then(() => {
				this.CartItemsState.emptyCurrentCart();

				this.ItemsState.fetchItemDetailsPack(this.getUrlParams());
			});
		}
	}

	render() {
		const { fetchItemDetailsPack } = this.props.ItemsState;

		return (
			<div className="ItemDetails">
				{fetchItemDetailsPack.handle({
					loading: () => <Loader />,
					rejected: error =>
						<div>
							{error.status === INTERNAL_ERROR || error.status === BAD_REQUEST
								? <ErrorLoadingContent />
								: <div className="ItemPackError">
										<PageHeader
											headerText={
												<span>
													<FormattedMessage id="packDetails.headerText" />
												</span>
											}
										/>
										<Alert
											type="danger"
											msgId={`packdetails.${error.message}`}
										/>
									</div>}
						</div>,
					resolved: items => {
						const [packDetails] = items.packDetails;
						const packItems = items.packItems.items;

						return (
							<div className="ItemDetailsPack">
								<PromotionBreadcrumb
									promotionName={packDetails.promotion_name}
									categoryName={packDetails.category_name}
									itemDetails={packDetails}
								/>

								<ItemContentHeader
									handleAddToCart={this.handleAddToCart.bind(this)}
									disableAddToCart={
										this.CartItemsState.hasError ||
										this.CartState.addToCart.state.loading ||
										packDetails.is_preview
									}
								>
									<GoBack
										goBackText="general.continueShopping"
										history={this.history}
									/>
								</ItemContentHeader>

								<div className="ItemDetails-content-item">
									<div className="row item-details">
										<ItemPreview
											showChooseColor={this.showModal}
											item={packDetails}
											itemsInPack={packItems.length}
											toggleModal={this.toggleModal.bind(this)}
											handleAddToCart={this.handleAddToCart.bind(this)}
										/>

										<div className="col-md-10">
											<DataTable
												id="ItemDetailsPack-info-table"
												columns={getColumnsItem(
													this.onChangeQty.bind(this),
													this.onBlurHandler.bind(this)
												)}
												rows={items.packDetails}
											/>
										</div>
									</div>
								</div>

								{items.packItems.items &&
									<div className="ItemDetailsPack-content--item-pack">
										<DataTable
											id="ItemDetailsPack-components-table"
											columns={getColumnsPack(items.packItems.totalCount)}
											rows={packItems}
										/>
									</div>}
							</div>
						);
					},
				})}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/pages/ItemDetailsPack/index.js